var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PAKISTAN_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056416572653853292200000004635793498827732153_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056416572653853292200000004635793498827732153__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.3146 0.664062H9.14062V20.2461H34.3146V0.664062Z",
    fill: "#2A680B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056416572653853292200000004635793498827732153__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_42550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.1989 4.58203C24.4369 4.58203 27.0599 7.21103 27.0599 10.453C27.0599 13.699 24.4369 16.328 21.1989 16.328C17.9609 16.328 15.3359 13.699 15.3359 10.453C15.3359 7.21103 17.9609 4.58203 21.1989 4.58203Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M19.1286 5.09396C21.3476 3.12096 24.7396 3.32097 26.7126 5.54697C28.6856 7.76197 28.4856 11.168 26.2676 13.145C24.0486 15.122 20.6526 14.918 18.6796 12.696C16.7106 10.477 16.9096 7.06996 19.1286 5.09396Z",
    fill: "#2A680B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M25.578 6.55469L23.791 7.33569L24.184 8.2337L25.578 6.55469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M25.5781 6.55469L24.592 8.2417L23.748 7.7457L25.5781 6.55469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M25.8073 8.8439L24.5062 7.37891L23.7812 8.03091L25.8073 8.8439Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M25.8065 8.84375L23.8955 8.42175L24.1055 7.46875L25.8065 8.84375Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M23.3379 6.05859L23.5309 8.0076L24.5019 7.9136L23.3379 6.05859Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M23.3379 6.05859L24.6369 7.52261L23.9019 8.1716L23.3379 6.05859Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M23.7031 9.76602L24.6901 8.07404L23.8461 7.58203L23.7031 9.76602Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M23.7028 9.76575L23.5078 7.81577L24.4808 7.71875L23.7028 9.76575Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M22.1777 8.04672L24.0858 8.46472L24.2908 7.51172L22.1777 8.04672Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_42550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000170262554825945567280000016128779163180812680__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M34.3149 0.664062H0.753906V20.2461H34.3149V0.664062Z",
    fill: "white"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_42550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M22.1777 8.04672L23.9648 7.26172L24.3558 8.15973L22.1777 8.04672Z",
    fill: "white"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistan);
export default __webpack_public_path__ + "static/media/PAKISTAN.a859d6e630e6dcdd00eeabcefbcb3637.svg";
export { ForwardRef as ReactComponent };